const notFound = [
    {
        sectionId: "notFound",
        language: "en",
        title: "404",
        content: "The address you are looking for does not exist. Use the menu to navigate the website more comfortably.",
    },
    {
        sectionId: "notFound",
        language: "pt",
        title: "404",
        content: "O endereço que você está procurando não existe. Utilize o menu para navegar no site com maior comodidade.",
    }
]

export default notFound